// dispatchStore — 배차 계산기 입력값의 브라우저 저장소(localStorage · 사용자별).
//
// 저장 모양 = { v: 1, base: <공용 기본값 지문>, dirty: true, mode: 'ratio'|'qty', raw: { 칸 경로 → 글자 } }.
// 사용자가 값을 고쳤을 때만 쓴다(dirty) — 안 고친 사용자는 저장값이 없어 새 공용 기본값을 그대로 받는다.
// base 는 «고칠 때 보던 공용 기본값»의 지문(dispatchCalc.defaultsFingerprint) — 지금 지문과 다르면 화면이 배너를 띄운다.
//
// 🔴 키는 **사용자별**이다(utils/stickerRecent.js 와 같다) — 같은 PC 를 둘이 쓸 때 남의 값이 보이면 안 된다.
// 🔴 사용자 id 를 모르면(로그인 전·목) **읽지도 쓰지도 않는다.** 공유 키를 두지 않는다.
// 🔴 localStorage 접근은 전부 함수 안 try/catch 다. 모듈 최상위에서는 저장소를 건드리지 않는다.
import { getGatewayUserId } from '../../lib/ncSso';

export const STORE_KEY_PREFIX = 'ourbox-dispatch-v11:';
const MODES = ['ratio', 'qty'];

/** 지금 로그인한 사용자 id(글자) — 모르면 null. */
export function currentUid() {
  try {
    return getGatewayUserId() || null;
  } catch (e) {
    return null;
  }
}

/** 사용자별 키 — uid 가 없으면 빈 글자(= 저장소를 쓰지 않는다). */
export function storeKey(uid) {
  return uid === undefined || uid === null || uid === '' ? '' : STORE_KEY_PREFIX + String(uid);
}

const isObject = (v) => !!v && typeof v === 'object' && !Array.isArray(v);

/** 저장값 { v, base, dirty, mode, raw } — 없거나 모양이 틀리면(깨진 JSON 포함) null. */
export function readSaved(uid) {
  const key = storeKey(uid);
  if (!key) return null;
  let text = null;
  try {
    text = localStorage.getItem(key);
  } catch (e) {
    return null;
  }
  if (!text) return null;
  let data = null;
  try {
    data = JSON.parse(text);
  } catch (e) {
    return null;
  }
  if (!isObject(data)) return null;
  if (data.v !== 1 || data.dirty !== true || typeof data.base !== 'string') return null;
  if (!MODES.includes(data.mode) || !isObject(data.raw)) return null;
  return { v: 1, base: data.base, dirty: true, mode: data.mode, raw: data.raw };
}

/** 고친 값을 저장한다 — uid 가 없으면 아무것도 하지 않는다. */
export function writeSaved(uid, { base, mode, raw }) {
  const key = storeKey(uid);
  if (!key) return;
  try {
    localStorage.setItem(key, JSON.stringify({ v: 1, base: String(base ?? ''), dirty: true, mode, raw }));
  } catch (e) {
    /* 저장 실패(용량·사생활 보호 모드)는 계산을 막지 않는다 */
  }
}

/** 저장값을 지운다(기본값으로 되돌리기·새 기본값 적용·내가 저장한 직후). */
export function clearSaved(uid) {
  const key = storeKey(uid);
  if (!key) return;
  try {
    localStorage.removeItem(key);
  } catch (e) {
    /* 지우지 못해도 다음 읽기에서 base 가 다르면 배너로 알린다 */
  }
}
